var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":_vm.title,"label-for":"summaryvalueper"}},[_c('span',{staticClass:"h5 text-uppercase",attrs:{"id":"summary value per"}},[_vm._v(" "+_vm._s(_vm.format(_vm.value))+" / "+_vm._s(_vm.freq)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }